import React from 'react';
import './notification.less';

interface INotification {
  message: string;
}
const Notification: React.FunctionComponent<INotification> = ({ message }) => {
  const isDeskTop = window.innerWidth > 1024;
  const isOverMaxWidth = window.innerWidth > 1980;
  const sideWidth = document.getElementsByClassName('course-left-side').length
    ? document.getElementsByClassName('course-left-side')[0].clientWidth
    : 0;

  return (
    <div
      className={`notification fade-in `}
      style={
        isOverMaxWidth
          ? {
              paddingLeft: `${sideWidth}px`,
              width: `calc(100% - ${sideWidth > 0 ? '2.5rem' : '5rem'})`,
            }
          : isDeskTop
          ? {
              paddingLeft: `calc(${sideWidth}px)`,
              width: `calc(100% - 5rem)`,
              maxWidth: `calc(1980px - 5rem)`,
            }
          : {}
      }
    >
      <div className="message">{message}</div>
    </div>
  );
};

export default Notification;
